import { buildMode, BuildMode } from "@/services/buildMode";

enum Event {
  RegistrationDone = "registration_done",
  Purchase = "purchase",
  AddToCart = "add_to_cart",
  ViewCart = "view_cart",
}

type EcommerceData = {
  value: number;
  currency: string;
};

type EventPayload = { event: Event.Purchase; ecommerce: EcommerceData } | { event: Exclude<Event, Event.Purchase> };

const isTrackingAllowed = (): boolean => {
  const allowedModes = [BuildMode.Production];
  return allowedModes.includes(buildMode);
};

const trackEvent = (payload: EventPayload): void => {
  if (!isTrackingAllowed()) {
    return;
  }
  if (!Array.isArray(window.dataLayer)) {
    console.warn("GTM dataLayer not found.");
    return;
  }
  window.dataLayer.push(payload);
  if (payload.event === Event.RegistrationDone) {
    window.gtag?.("event", "conversion", { send_to: "AW-16714161893/FxbOCIGTq_MZEOW996E-" });
  }
};

export default {
  trackEvent,
  Event,
};
